import { defineComponent } from "vue";
import BaseFooter from "@/components/Shared/BaseFooter/BaseFooter.vue";
import ThemesHelper from "@/helpers/ThemesHelper";
import GoogleAnalyticsEvents from "@/helpers/GoogleAnalyticsEvents";
import ButtonStartTest from "@/components/Shared/Home/ButtonStartTest/ButtonStartTest.vue";

export default defineComponent({
  components: {
    BaseFooter,
    ButtonStartTest,
  },
  data() {
    return {
      testName: ThemesHelper.getThemeParams("testName"),
      testImage: ThemesHelper.getThemeParams("urlPathTestImage"),
    };
  },
  mounted() {
    this.testImage = require(`@/assets/themes/${this.testImage}`);
  },
  methods: {
    GAinitRegisterTest() {
      GoogleAnalyticsEvents.initRegisterTest();
      this.$router.push({ name: "RegisterTestCovid" });
    },
  },
});
